import Affix from './affix.vue';
export default Affix;


// WEBPACK FOOTER //
// ./src/components/affix/index.js